<!-- Permissions -->
<div [appEnforcePermission]="authConfig.investigationPartiesList" #investigationPartiesList="appEnforcePermission"></div>
<!-- Permissions -->
<div class="kendo-formfield left-search-icon multi">
  <kendo-label [for]="" text="{{label}}"></kendo-label>
  <div style="position: relative;">
    <i class="fa fa-search" aria-hidden="true"></i>
    <kendo-multiselect #multiSelect
      [checkboxes]="true"
      [autoClose]="false"
      [loading]="loading"
      [valuePrimitive]="true"
      [data]="insuredParties"
      [(ngModel)]="selectedValue"
      [rounded]="'full'"
      (valueChange)="selectCompany($event)"
      (keydown.enter)="onEnterPress()"
      valueField="id"
      textField="insuredName"
      [tagMapper]="tagMapper"
      [placeholder]="placeholder"
      [fillMode]="'outline'"
      [kendoDropDownFilter]="{caseSensitive: false, operator: 'startsWith'}"
      (focus)="onSearchFocus()"
      (filterChange)="onSearchChange($event)"
      [disabled]="!investigationPartiesList?.enabled">
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <span style="padding-left: 5px;">{{ dataItem?.insuredName }}</span>
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="!searchString?.trim()?.length">
        PLEASE SEARCH SOMETHING...
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="searchString?.trim()?.length">
        NO DATA FOUND
      </ng-template>
    </kendo-multiselect>
  </div>
</div>
